import { EventEmitter } from 'events';
const $ = window.jQuery;



let ret = false;

export default function init() {
	if (ret !== false) return ret;
	ret = (function() {
		const $body = $('body');
		const toReturn = {};
		let state = 'CLOSED'; // CLOSED, CLOSING, OPENING, OPEN
		const HTML = `
			<div class="lightbox">
				<div class="lightbox__inner">
					<button class="lightbox__close">Close</button>
					<div class="lightbox__content"></div>
				</div>
			</div>
		`;
		const $lightbox = $(HTML);
		const $lightboxClose = $lightbox.find('.lightbox__close');
		const $lightboxContent = $lightbox.find('.lightbox__content');

		const open = () => {
			state = 'OPENING';
			$body.css('overflow', 'hidden');
			$lightbox.addClass('lightbox--block');
			requestAnimationFrame(() => {
				if (state !== 'OPENING') {
					toReturn.events.emit('OPEN_ERROR');
					return;
				}

				requestAnimationFrame(() => {
					if (state !== 'OPENING') {
						toReturn.events.emit('OPEN_ERROR');
						return;
					}
					$lightbox.addClass('lightbox--show');
					state = 'OPEN';
					toReturn.events.emit('OPEN');
				});
			});
		};

		const close = () => {
			state = 'CLOSING';
			$lightbox.removeClass('lightbox--show');
		};

		const changeHTML = (HTML) => {
			$lightboxContent.html(HTML);
		};

		$lightbox[0].addEventListener('transitionend', () => {
			if (state === 'CLOSING') {
				$lightbox.removeClass('lightbox--block');
				$body[0].style.overflow = ''; // quotes instead of null work in ie
				state = 'CLOSED';
				toReturn.events.emit('CLOSED');
			}
		});



		toReturn.open = open;
		toReturn.close = close;
		toReturn.changeHTML = changeHTML;
		toReturn.returnLightbox = () => $lightbox;
		toReturn.isOpen = () => state === 'OPEN';
		toReturn.events = new EventEmitter();

		$('body')
		.on('click', (e) => {
			const $target = $(e.target);
			if ($target.is($lightbox)) close();
			if ($target.is($lightboxClose) || $target.parents('.lighbox__close').length !== 0) close();
		})
		.append($lightbox);

		ret = toReturn;
		return ret;

	}());
	return ret;
}
